import React, { useState, useEffect } from 'react';
import thumbnail from "../../Images/blogbanner.png"
import author from "../../Images/CRYSTAL.png"
import Blogcontact from "../Contact/Blogcontact";
import { NavBar } from "../navbar";
import Footer from "../Footer";
import {useParams} from "react-router-dom";
import axios from 'axios';
import Url from 'src/Url';
import { useNavigate } from "react-router-dom";
import MetaTags from 'react-meta-tags';

const Detailedblog = () => {
   const [blog, setBlog] = useState({});
   const { id } = useParams();
   const [popular, setPopular]= useState([]);
   const navigate = useNavigate();
   const [posts, setPosts] = useState([]);
  const [activeTab, setActiveTab] = useState("popular");

  const goToBlogDetail = (id) => {
    navigate(`/detailed-post/${id}`); 
};


  var date = new Date(blog?.created_at*1000);
  const formattedDate = date.toLocaleDateString(); 


  const getRecent=(p)=>{

    
    const FormData = require('form-data');
    let data = new FormData();
    data.append('key', 'mypassword');
    data.append('page', p);
    
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: Url.apiUrl+'blog/list/',
      headers: { 
        'Content-Type': 'multipart/form-data'
      },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      setPosts(posts=>response.data); //assign data to posts
      var t= []
      if (Array.isArray(response.data)) {
        t.push(response.data[0])
      t.push(response.data[1])
    }
      setPopular(popular=>t)// assign data to popular posts
    })
    .catch((error) => {
      console.log(error);
    });
    

  }


  const getBlog = () => {
    const FormData = require('form-data');  
    let data = new FormData();
    data.append('blog_id',id);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: Url.apiUrl+'blog/detail/',
      headers: { 
      'Content-Type': 'multipart/form-data'
      },
      data : data
    };

    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      setBlog(blog=>response.data.blog)
    })
    .catch((error) => {
      console.log(error);
    });

  }


  // useEffect(()=>{
  //   getBlog()
  //   getRecent(1)

  // },[])

  useEffect(() => {
    getBlog();
    getRecent(1);
    window.scrollTo(0, 0);
  }, [id]); // Add 'id' to dependencies
  

  return (
    <>
    <NavBar/>
    <div>
      {/* Banner Section */}
      <div className="blog-detail-banner"   style={{ backgroundImage: `url(${Url.blogimg+blog.featured_image})` }}>
        <h1>{blog?.title}</h1>
      </div>

      <div className="blog-detail-content-container">
        {/* Blog Section */}
        <div className="blog-detail-blog-section">
  <h2>{blog?.title}</h2>
  <div
              className="post-body"
              dangerouslySetInnerHTML={{ __html: blog?.content }}
            >
 </div>
  {/* Tags Section */}
  <div className="blog-detail-tags">
    <h2>Tags</h2>
    {blog.tags && typeof blog.tags === 'string' ? (
                blog.tags.split(',').map((tag, tagIndex) => (
    <span className="blog-detail-tag"key={tagIndex}>{tag}</span>

))
) : (
  <span>No tags available</span>
)}
    </div>

  <div className="blog-detail-author-container">
  {blog?.author_id && (
  <div className="author-left">
    <img src={author} alt="Author" className="author-image" />
    <h4 className="author-name">{blog.author_id}</h4>
  </div>
   )}
  <div className="author-right">
    <p className="author-bio">Author's Bio: Experienced IT professional with expertise in system maintenance and business operations.</p>
  </div>
</div>

</div>


        {/* Sidebar Section */}
        <div className="blog-detail-sidebar">
          <div className="blog-detail-tab-buttons">
            <button 
              className={activeTab === "popular" ? "active" : ""} 
              onClick={() => setActiveTab("popular")}
            >
              Popular Post
            </button>
            <button 
              className={activeTab === "recent" ? "active" : ""} 
              onClick={() => setActiveTab("recent")}
            >
              Recent Post
            </button>
          </div>

          {activeTab === "popular" ? (
  popular.map((post, index) => {
    var date = new Date(post?.created_at * 1000);
    const formattedDate = date.toLocaleDateString();
    return (
      <div className="blog-detail-post-content" key={index}>
        <img src={Url.blogimg + post?.featured_image} alt="Post Thumbnail" className="blog-detail-post-image" />
        <div className="blog-detail-post-details">
          <p className="blog-detail-post-date">{formattedDate}</p>
          <h3 className="blog-detail-post-title">
          <a onClick={() => goToBlogDetail(post.slug)}>{post?.title}</a>
          </h3>
        </div>
      </div>
    );
  })
) : (
  posts.slice(0, 2).map((post, index) => { // Ensures only 2 recent posts are shown
    var date = new Date(post?.created_at * 1000);
    const formattedDate = date.toLocaleDateString();
    return (
      <div className="blog-detail-post-content" key={index}>
        <img src={Url.blogimg + post?.featured_image} alt="Post Thumbnail" className="blog-detail-post-image" />
        <div className="blog-detail-post-details">
          <p className="blog-detail-post-date">{formattedDate}</p>
          <h3 className="blog-detail-post-title">
            <a onClick={() => goToBlogDetail(post.slug)}>{post?.title}</a>
          </h3>
        </div>
      </div>
    );
  })
)}



<div className="blog-detail-contact-main"> 
<h3 className="blog-detail-contact-title">Reach Out To Us</h3>

<Blogcontact/>
      
</div>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Detailedblog;
